import { useTranslation } from "react-i18next"
import { DotPill, Tone } from "../../delivery/atoms"

const TONES: Record<string, Tone> = { OPEN: "red", IN_PROGRESS: "amber", RESOLVED: "green", CLOSED: "grey" }

export function InboundExceptionStatusBadge({ status }: Readonly<{ status: string | null | undefined }>) {
  const { t } = useTranslation("inbound")
  if (!status) return <>-</>
  return <DotPill tone={TONES[status] ?? "grey"}>{t(`exceptionStatus.${status}`, { defaultValue: "-" })}</DotPill>
}
